import React from "react";
import { ColumnDef } from "@tanstack/react-table";
import { CommercialUserProps } from "modules/user_management/commercial_user/user/state/actionType";

export const TableColumns: ColumnDef<CommercialUserProps>[] = [
  {
    id: "slNo",
    header: "Sl. No",
    cell: ({ row }) => row.index + 1,
  },
    {
    accessorFn: (row) => row.user_identifier,
    id: "user_identifier",
    header: "User Identifier",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.email,
    id: "email",
    header: "Email",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.mobile_no,
    id: "mobile_no",
    header: "Mobile No.",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.status,
    id: "status",
    header: "Status",
    cell: (info) => info.getValue(),
  },
];
